var map = {
	"./AUDUSD-Model-Card.json": [
		6513,
		513
	],
	"./Boom 1000 Index-Model-Card.json": [
		3559,
		559
	],
	"./Crash 1000 Index-Model-Card.json": [
		2491,
		491
	],
	"./EURUSD-Model-Card.json": [
		4979,
		360
	],
	"./GBPUSD-Model-Card.json": [
		7960,
		960
	],
	"./USDCAD-Model-Card.json": [
		2979,
		979
	],
	"./USDCHF-Model-Card.json": [
		6146,
		146
	],
	"./USDJPY-Model-Card.json": [
		268,
		268
	],
	"./USDZAR-Model-Card.json": [
		7732,
		732
	],
	"./Volatility 75 (1s) Index-Model-Card.json": [
		1343,
		343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5234;
module.exports = webpackAsyncContext;